import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { LocationConfigurationHolder } from "../../LocationConfiguration";
import { ReservesSearchSortType } from "./Reserves/ReservesSearchSortType";
import { ReservesOptionsHolder } from "./Reserves/ReservesSearchProvider";

export async function reservesLoader({ request }: LoaderFunctionArgs) {
  console.log("reservesLoader executing");

  const { pacSettings } =
    await LocationConfigurationHolder.fetchLocationConfiguration();

  if (!pacSettings.reservesEnabled) {
    throw new Response("Not Found", { status: 404 });
  }

  const allOptions = await ReservesOptionsHolder.getAllOptions();

  const url = new URL(request.url);
  const sortParam = url.searchParams.get("sortKey");
  const departmentParam = url.searchParams.get("department");
  const courseParam = url.searchParams.get("course");
  const instructorParam = url.searchParams.get("instructor");
  const validSortKeys = Object.values(ReservesSearchSortType);
  let redirectParams = false;

  if (
    sortParam &&
    !validSortKeys.includes(sortParam as ReservesSearchSortType)
  ) {
    url.searchParams.delete("sortKey");
    redirectParams = true;
  }

  if (
    departmentParam &&
    !allOptions.departments.find((o) => o.value === departmentParam)
  ) {
    url.searchParams.delete("department");
    redirectParams = true;
  }

  if (courseParam && !allOptions.courses.find((o) => o.value === courseParam)) {
    url.searchParams.delete("course");
    redirectParams = true;
  }

  if (
    instructorParam &&
    !allOptions.instructors.find((o) => o.value === instructorParam)
  ) {
    url.searchParams.delete("instructor");
    redirectParams = true;
  }

  if (redirectParams) {
    return redirect(url.toString());
  }

  return { allOptions };
}
